export const config = {
  mode: 'delete',
  getTitleText: (count, itemLabel) => `Delete ${count > 0 ? `${count} ` : ''}${itemLabel}`,
  titleIcon: 'delete',
  okText: 'Delete',
  okButtonDanger: true,
  width: 420,
  getBodyText: (count, singularLabel, itemLabel, itemTitle) =>
    itemTitle
      ? `Are you sure you want to delete the ${itemTitle} ${singularLabel}?`
      : count > 1
        ? `Are you sure you want to delete ${count} selected ${itemLabel}?`
        : `Are you sure you want to delete this ${singularLabel}?`,
  footerNote: 'This action cannot be undone.',
  fields: [],
};
